import { TARGET } from "../../constants/target.qwik.mjs";
import { logger } from "../../helpers/logger.qwik.mjs";
import { getSdkHeaders } from "../../helpers/sdk-headers.qwik.mjs";
import { getSessionId } from "../../helpers/sessionId.qwik.mjs";
import { getVisitorId } from "../../helpers/visitorId.qwik.mjs";
import { isBrowser } from "../is-browser.qwik.mjs";
import { isEditing } from "../is-editing.qwik.mjs";
import { logFetch } from "../log-fetch.qwik.mjs";
import { getUserAttributes } from "./helpers.qwik.mjs";
const getTrackingEventData = async ({ canTrack }) => {
  if (!canTrack)
    return {
      visitorId: void 0,
      sessionId: void 0
    };
  const sessionId = await getSessionId({
    canTrack
  });
  const visitorId = getVisitorId({
    canTrack
  });
  return {
    sessionId,
    visitorId
  };
};
const createEvent = async ({ type: eventType, canTrack, apiKey, metadata, ...properties }) => ({
  type: eventType,
  data: {
    ...properties,
    metadata: {
      url: location.href,
      ...metadata
    },
    ...await getTrackingEventData({
      canTrack
    }),
    userAttributes: getUserAttributes(),
    ownerId: apiKey
  }
});
async function _track({ apiHost, ...eventProps }) {
  if (!eventProps.apiKey) {
    logger.error("Missing API key for track call. Please provide your API key.");
    return;
  }
  if (!eventProps.canTrack)
    return;
  if (isEditing())
    return;
  if (!(isBrowser() || TARGET === "reactNative"))
    return;
  const baseUrl = apiHost || "https://cdn.builder.io";
  const url = `${baseUrl}/api/v1/track`;
  logFetch(url);
  return fetch(url, {
    method: "POST",
    body: JSON.stringify({
      events: [
        await createEvent(eventProps)
      ]
    }),
    headers: {
      "content-type": "application/json",
      ...getSdkHeaders()
    },
    mode: "cors"
  }).catch((err) => {
    console.error("Failed to track: ", err);
  });
}
const track = (args) => _track({
  ...args,
  canTrack: true
});
export {
  _track,
  track
};
